import intro3 from '@/assets/mocks/intro-3.webp'

import './IntroSlide3.scss'

export function IntroSlide3() {
  return (
    <div className="intro-slide-3">
      <div className="intro-slide-3__questions">
        <p className="intro-slide-3__question intro-slide-3__question--faded">How was your experience?</p>
        <p className="intro-slide-3__question intro-slide-3__question--medium">How do you feel?</p>
        <p className="intro-slide-3__question intro-slide-3__question--bold">
          What would you do differently next time?
        </p>
      </div>

      <img src={intro3} alt="Feedback goals" className="intro-slide-3__goals-image" loading="lazy" decoding="async" />
    </div>
  )
}
